import { PDFSections } from '@/types';

export const RESULT_PDF_SECTIONS: PDFSections[] = [
	PDFSections.KIM_MHO,
	PDFSections.NIOSH,
	PDFSections.REBA,
	PDFSections.ACTION_PLANS,
	PDFSections.NOT_EVALUATED,
	PDFSections.LIBERTY_MUTUAL,
	PDFSections.BACK_COMPRESSIVE_FORCE_ESTIMATION
];
